<template>
  <div id="Register">
    <div class="pt-1">
      <div class="m-2">
        <van-cell-group class="text-left border-radius">
          <van-field v-model="user_info.RealName" label="姓名" placeholder="姓名" />

          <van-field>
            <template slot="label">性别</template>
            <template slot="input">
              <div
                @click="(user_info.UserSex==1) ? user_info.UserSex = 2 : user_info.UserSex = 1"
              >{{ (user_info.UserSex==1)?'男':'女' }}</div>
            </template>
          </van-field>

          <van-field v-model="user_info.UserIDCard" label="证件号码" placeholder="证件号码" />

          <van-field v-model="user_info.Tel" label="座机号码" placeholder="座机号码" />

          <van-field v-model="user_info.Phone" label="手机号码" placeholder="手机号码" />

          <van-field v-model="user_info.Address" label="联系地址" placeholder="联系地址" />
        </van-cell-group>

        <van-button plain hairline type="primary mt-4 w-100" @click="upBtn">更新</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  id: "Register",
  data() {
    return {
      user_info: {
        RealName: "",
        UserSex: 1,
        UserIDCard: "",
        Tel: "",
        Phone: "",
        Address: ""
      }
    };
  },
  methods: {
    upBtn: function() {
      /**验证手机号 */
      if (!/^1[3456789]\d{9}$/.test(this.user_info.Phone)) {
        this.$toast("手机号码有误");
        return false;
      }
      this.user_info["Flg"] = 'other'
      this.apiUserPut(this.user_info, this, e => {
        this.$toast(e.message);
        if (e.code == 20000) {
          this.$router.push({
            name: "Setting"
          });
        }
      });
    }
  },
  created() {
    this.apiUserGet(this, e => {
      this.user_info.RealName = e.data.RealName;
      this.user_info.UserSex = e.data.UserSex;
      this.user_info.UserIDCard = e.data.UserIDCard;
      this.user_info.Tel = e.data.Tel;
      this.user_info.Phone = e.data.Phone;
      this.user_info.Address = e.data.Address;
    });
  }
};
</script>

<style scoped>
#Register {
  background: #efefef;
  min-height: 700px;
}
</style>
